// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1ojlg","tiny":"_58Not","secondary":"_3pXTM","disabled":"_2_L5z"};